import { render } from "./FeedbackDashboardPage.vue?vue&type=template&id=3f3471d4&scoped=true&ts=true"
import script from "./FeedbackDashboardPage.vue?vue&type=script&lang=ts"
export * from "./FeedbackDashboardPage.vue?vue&type=script&lang=ts"

import "./FeedbackDashboardPage.vue?vue&type=style&index=0&id=3f3471d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3471d4"]])

export default __exports__